import template from './was-this-useful-user-check.component.html';
var WasThisUsefulUserCheckComponentController = /** @class */ (function () {
    function WasThisUsefulUserCheckComponentController() {
    }
    return WasThisUsefulUserCheckComponentController;
}());
export var WasThisUsefulUserCheckComponent = {
    bindings: {
        onNameChange: '&?',
    },
    controller: WasThisUsefulUserCheckComponentController,
    template: template,
};
